import { clientsLogsListOptions } from '@crm/api'
import { ActivityLogItem } from '@crm/components/InfoTabs/Tabs/ActivityCol/ActivityLogItem'
import { usePaginationConfigCrm, useQueryUpdateCrm } from '@crm/hooks'
import { LogType } from '@crm/types'
import { useLocales } from '@shared/locales'
import { useQuery } from '@tanstack/react-query'
import { Empty, Flex, Pagination, Select, Spin } from 'antd'
import { useParams } from 'react-router-dom'

export const ClientLogsCol = () => {
  const { t } = useLocales()
  const { id } = useParams()
  const { params, updateQuery } = useQueryUpdateCrm()

  const { data, isLoading } = useQuery({
    ...clientsLogsListOptions({
      path: { client_id: id! },
      query: { ...params }
    }),
    enabled: !!id
  })

  const pagination = usePaginationConfigCrm(data)

  return (
    <Flex vertical gap={16}>
      <Flex>
        <Select
          placeholder={t('logs.type')}
          value={
            Array.isArray(params.type)
              ? params.type
              : params.type && [params.type]
          }
          mode="multiple"
          className="select-min-width"
          options={Object.values(LogType).map((item) => ({
            label: t(`logs.${item}`),
            value: item
          }))}
          onChange={(type) => updateQuery({ type })}
        />
      </Flex>

      <Spin spinning={isLoading}>
        <Flex vertical gap={16}>
          {data && <ActivityLogItem logs={data.results} />}

          {data?.results.length === 0 && <Empty />}

          {data && <Pagination {...pagination} />}
        </Flex>
      </Spin>
    </Flex>
  )
}
